import React from "react";
import { AuthProvider } from "./src/auth/AuthProvider";
import "./src/styles/global.css";
import "./src/styles/animations.css";

// Add favicon meta tags
export const wrapRootElement = ({ element }) => {
  if (typeof window !== 'undefined') {
    // Ensure favicon link exists
    let faviconLink = document.querySelector('link[rel="icon"]');
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      faviconLink.href = '/favicon.svg';
      faviconLink.type = 'image/svg+xml';
      document.head.appendChild(faviconLink);
    }
    
    // Add apple touch icon
    let appleLink = document.querySelector('link[rel="apple-touch-icon"]');
    if (!appleLink) {
      appleLink = document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      appleLink.href = '/favicon-32x32.png';
      document.head.appendChild(appleLink);
    }
  }
  // Optional sign-in (src/auth): the context is everywhere, the Firebase SDK is not.
  return <AuthProvider>{element}</AuthProvider>;
};

// Smoothly scroll to top on route changes
export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
